import { Icon } from '@mui/material';

const LogoIcon = ({ logo }) => (
    <Icon>
        <img src={logo} height={25} width={25} />
    </Icon>
);

export default LogoIcon;
